import React, { useState, FormEvent, useEffect } from 'react';

import { useParams } from 'react-router-dom';

import { Suggest, Suggest2, ItemRenderer, ItemPredicate } from '@blueprintjs/select';
import { FormGroup, InputGroup, AnchorButton, Button, Tabs, Tab, Collapse, HTMLSelect, HTMLTable, ControlGroup, NumericInput, TextArea, Position, Toaster, Intent, MenuItem } from "@blueprintjs/core";
import { Checkbox, Radio, RadioGroup, Switch, Alert, Dialog, DialogBody, Callout } from "@blueprintjs/core";
import { H2, H3, H4, H5, H6 } from "@blueprintjs/core";
import { Classes, Card, Elevation } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";


import { AxiosInstance } from 'axios';

import * as utils from "../utils";

import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import svgWait2 from '../svg/wait2.gif'

import { FBSCbMast, FBSCCYInfo } from '../Types'
import { SystemHeader, FBSClientPicker, FBSCCYSuggest } from '../CommonUI';
import { Pagination, PageInfo } from '../CommonUI';

import i18next from 'i18next';


var GsbFlag: any;

var UserID: string;
var PgmCode = "M0001" ;
var isReqAuth2:boolean = false ;

interface FBSCbMastViewProps {
    gsb: AxiosInstance,
    cb: FBSCbMast,
    baseUrl?: string,
    token?: string | null,
    disableMovement?: boolean,
    onPrevRec?: () => void,
    onNew?: () => void,
    onEdit?: () => void,
    onDelete?: () => void,
    onNextRec?: () => void,
}


export function FBSCbMastView({ gsb, cb = {} as FBSCbMast, baseUrl = "", token = "", disableMovement = false, onPrevRec = () => { }, onNew = () => { }, onEdit = () => { }, onDelete = () => { }, onNextRec = () => { } }: FBSCbMastViewProps) {


    const { t, i18n } = useTranslation();    

    const [isReadOnly, setisReadOnly] = useState(false)
    const [isReqAuth, setisReqAuth] = useState(false)
    const [isDeletePress, setisDeletePress] = useState(false)

    useEffect(() => {
        (async () => {
            try {
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');
                GsbFlag = res.data.Flag;
 
            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])
    
/*
    useEffect(() => {
        if ( GsbFlag.Enter2tab == "Y" ) {
            let inputs = utils.PerformEnter2Tab()
        }
    }, [])
*/

    useEffect(() => {
        setisReadOnly(false)
        setisReqAuth(false)
        isReqAuth2 = false
        ;
        (async () => {
            try {
                UserID = (typeof UserID === 'string')? UserID.trim() : ''
                if ( UserID.trim().length > 0 ) {
                    const res = await gsb.post('/Master', {
                        sb_data: {
                            d_Userid2: UserID,
                            d_PgmCode: PgmCode
                        }, 
                        cPgmId: "UserPgmAccess", 
                        cAction: "GetUserPgmAccessInfo2"
                    })

                    if (res.data.ok) {
                        if ( res.data.data[0].d_PgmAction == "R" ) {
                            setisReadOnly(true)
                        }
                        if ( res.data.data[0].d_PgmAction == "M" || res.data.data[0].d_PgmAction == "C") {
                            //setisReqAuth(true)
                            //isReqAuth2 = true
                        }
                    }
                }
            } catch (error) {
                showErrorBox(error)
            }
        })()            
    }, [gsb, UserID, cb])

    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }

    if (! ("d_Acct" in cb)) return null


    return (
        <div>
            {/* define add,change,delete button */}
            <div className="Row">
                <Button className="Col-1-1" disabled={disableMovement} icon="direction-left" onClick={() => onPrevRec()} >Prev</Button>
                
                <Button className="Col-2-1" disabled={isReadOnly} icon="add" onClick={() => onNew() } >New</Button>
                <Button className="Col-3-1" disabled={isReadOnly} icon="edit" onClick={() => onEdit() } >Edit</Button>
                <Button className="Col-4-1" disabled={isReadOnly} icon="delete" onClick={() => setisDeletePress(true) } >Delete</Button>
                    <Alert
                        cancelButtonText="Cancel"
                        confirmButtonText="Delete"
                        canEscapeKeyCancel={true}
                        icon="trash"
                        intent={Intent.DANGER}
                        isOpen={isDeletePress}
                        onCancel={ () => setisDeletePress(false) }
                        onConfirm={ () => { onDelete(); setisDeletePress(false) } }
                    >
                        <p>
                            Are you sure to Delete ?
                        </p>
                    </Alert>
                
                <Button className="Col-5-1" disabled={disableMovement} icon="direction-right" onClick={() => onNextRec()} >Next</Button>
            </div>

            <div className="Spacing-V-16" />
            <div className="Row">
                <FormGroup className="Col-1-1" label="Account">
                    <InputGroup readOnly value={cb.d_Acct} />
                </FormGroup>
                <FormGroup className="Col-2-3" label="Name">
                    <div id="DispText">{cb.d_acName1}</div>
                </FormGroup>
                <FormGroup className="Col-5-1" label="Currency">
                    <InputGroup readOnly value={cb.d_Curcy} />
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label="Interest Code">
                    <InputGroup readOnly value={cb.d_IntCode} />
                </FormGroup>
                <FormGroup className="Col-2-1" label="CR Interest">
                    <InputGroup readOnly value={utils.numToString2(cb.d_CrIntMTD)} />
                </FormGroup>
                <FormGroup className="Col-3-1" label="DR Interest">
                    <InputGroup readOnly value={utils.numToString2(cb.d_DrIntMTD)} />
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label="Last Month Net Equity">
                    <InputGroup readOnly value={utils.numToString2(cb.d_BalBF)} />
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label="Last Day Net Equity">
                    <InputGroup readOnly value={utils.numToString2(cb.d_BalMTD)} />
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label="Fund In/Out">
                    <InputGroup readOnly value={utils.numToString2(cb.d_InOut)} />
                </FormGroup>
                <FormGroup className="Col-2-1" label="Commission">
                    <InputGroup readOnly value={utils.numToString2(cb.d_Comm)} />
                </FormGroup>
                <FormGroup className="Col-3-1" label="Exchange Fee">
                    <InputGroup readOnly value={utils.numToString2(cb.d_Exchange)} />
                </FormGroup>
                <FormGroup className="Col-4-1" label="Levy">
                    <InputGroup readOnly value={utils.numToString2(cb.d_Levy)} />
                </FormGroup>
                <FormGroup className="Col-5-1" label="Profit & Loss">
                    <InputGroup readOnly value={utils.numToString2(cb.d_PL)} />
                </FormGroup>
                <FormGroup className="Col-6-1" label="Net Equity">
                    <InputGroup readOnly value={utils.formatMoney(cb.d_BalMTD+cb.d_InOut+cb.d_Comm+cb.d_Exchange+cb.d_Levy+cb.d_PL)} />
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label="Open Trade Equity">
                    <InputGroup readOnly value={utils.numToString2(cb.d_OTE)} />
                </FormGroup>
                <FormGroup className="Col-6-1" label="Total Equity">
                    <InputGroup readOnly value={utils.formatMoney(cb.d_BalMTD+cb.d_InOut+cb.d_Comm+cb.d_Exchange+cb.d_Levy+cb.d_PL + cb.d_OTE)} />
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label="Init. Margin">
                    <InputGroup readOnly value={utils.numToString2(cb.d_IMargin)} />
                </FormGroup>
                <FormGroup className="Col-2-1" label="Main. Margin">
                    <InputGroup readOnly value={utils.numToString2(cb.d_MMargin)} />
                </FormGroup>
                <FormGroup className="Col-6-1" label="Excess/(Deficit)">
                    <InputGroup readOnly value={utils.formatMoney(cb.d_BalMTD+cb.d_InOut+cb.d_Comm+cb.d_Exchange+cb.d_Levy+cb.d_PL + cb.d_OTE - cb.d_IMargin)} />
                </FormGroup>
            </div>
        </div>
    )
}

interface FBSCbMastEditProps {
    gsb: AxiosInstance,
    ccyList: FBSCCYInfo[],
    cb?: FBSCbMast,
    isNew?: boolean,
    onSave?: (stk: FBSCbMast) => void,
    onCancel?: () => void,
}

export function FBSCbMastEdit({ gsb, ccyList, cb = {} as FBSCbMast, isNew = false, onSave = () => { }, onCancel = () => { } }: FBSCbMastEditProps) {

    const { register, handleSubmit, reset, setValue, setError, errors } = useForm<FBSCbMast>()

    const { t, i18n } = useTranslation();    

    const [isReadOnly, setisReadOnly] = useState(false)
    const [isReqAuth, setisReqAuth] = useState(false)

    const [AcCodeValue, setAcCodeValue] = useState(cb.d_Acct)
    const [isClPickerOpen, setIsClPickerOpen] = useState(false)
    const [AcName1Value, setAcName1Value] = useState(cb.d_acName1)
    const [AcName2Value, setAcName2Value] = useState(cb.d_acName2)

    const [CCYValue, setCCYValue] = useState(ccyList.find((ccyInfo) => ccyInfo.d_Curcy === ("d_Curcy" in cb ? cb.d_Curcy : "HKD")))

    const [cardOpen01, setcardOpen01] = useState("cardOpen01-Theme0")

    useEffect(() => {
        (async () => {
            try {
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');
                GsbFlag = res.data.Flag;
 
                if ( GsbFlag.isProduction == "Y" ) {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME1);
                } else {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME2);
                }

            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])

    useEffect(() => {
        // Call reset to get the values of record ClientTranInfo 
        if ("d_Acct" in cb) {
            reset(cb)
        }
    }, [cb, reset])


    useEffect(() => {
        // Some components (e.g. Suggest) don't have ref to use with react-hook-form, so register the fields manually and call setValue when item is selected
        // register({ name: "d_FieldName" })
    }, [register])


    useEffect(() => {
        if ( GsbFlag.Enter2tab == "Y" ) {
            let inputs = utils.PerformEnter2Tab()
        }
    }, [])

    useEffect(() => {
        (async () => {
            try {
                const res = await gsb.post('/fbs/Master', {sb_data: "", cPgmId: "CLMast", cAction: "GetCLInfo", cAcct: AcCodeValue})
                
                if ( AcCodeValue.trim().length > 0 && res.data.count > 0 )
                {
                    setAcName1Value(res.data.data[0].d_Name)
                    setAcName2Value(res.data.data[0].d_Name2)

                } else { 
                    setAcName1Value("")
                    setAcName2Value("")
                }
               
            } catch (error) {
                //showErrorBox(error)
            }
        })()
    }, [gsb, AcCodeValue])

    if (! isNew && ! ("d_Acct" in cb)) return null

    let acNoLength = 12
   
    const onSubmit = (data: FBSCbMast) => {
        // put value to json/field before write database dbf
        data.d_Curcy = CCYValue?.d_Curcy || "";

        (async () => {
            try {
                const res = await gsb.post('/fbs/Master', {sb_data: data, cPgmId: "CBMast", cAction: "CBMastValidate", isNew: isNew})

                if (! res.data.ok) {
                    for (let j = 0; j < res.data.data.length; j++) {
                      
                        setError(res.data.data[j][0], {
                           message: res.data.data[j][1]
                        }); 
                    }

                    return
                }
                onSave(data)

            } catch (error) {
                showErrorBox(error)
            }
        })()
    }

    const handleHotkey = (e: React.KeyboardEvent<HTMLFormElement>) => {
        //console.log(`ctrl:${e.ctrlKey} alt:${e.altKey} shift:${e.shiftKey} meta:${e.metaKey} key:${e.key} keyCode:${e.keyCode}`)

        // ctrl + s
        if (e.ctrlKey && e.keyCode === 83) {
            e.preventDefault()
            handleSubmit(onSubmit)()
        }
    }

    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }

    return (
        <form onKeyDown={handleHotkey}>
            <FBSClientPicker gsb={gsb} isOpen={isClPickerOpen} onClose={()=>setIsClPickerOpen(false)} onSelect={(ac)=>{setAcCodeValue(ac.d_Acct); setIsClPickerOpen(false)}}/>
            <div className="Row">
                <Button className="Col-1-1" icon="cross" onClick={() => onCancel()}>Cancel</Button>
                <Button className="Col-2-1" icon="tick" onClick={handleSubmit(onSubmit)}>Save</Button>
                { isReqAuth && 
                    <Callout className="Col-6-2"
                        icon="warning-sign"
                        intent={Intent.WARNING}
                    >
                        Authorization Required
                    </Callout>
                }

             </div>
            <div className="Spacing-V-16" />
            <div className="Row">
                <FormGroup className="Col-1-1" label="Account" labelFor="d_Acct" labelInfo="*">
                    <InputGroup disabled={!isNew} id="d_Acct" name="d_Acct" value={AcCodeValue} placeholder="Account ..." onChange={utils.handleStringChange(s => setAcCodeValue(s.toUpperCase()))} inputRef={register({ required: true , maxLength: acNoLength}) }
                        rightElement={<Button icon="double-chevron-down" minimal onClick={() => {setIsClPickerOpen(true)}}></Button>}
                    />
                    {errors.d_Acct && errors.d_Acct.type === "required" && <span id="Err_msg">Account cannot be Blank</span>}
                    {errors.d_Acct && errors.d_Acct.type === "maxLength" && <span id="Err_msg">Max length is {acNoLength}</span>}
                    {errors.d_Acct && errors.d_Acct.types && <span id="Err_msg">{errors.d_Acct.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-2-3" label="Account Name">
                    <div id="DispText">{AcName1Value}</div>
                    <div id="DispText">{AcName2Value}</div>
                </FormGroup>
                <FormGroup className="Col-5-1" label="Currency" labelFor="d_Curcy" labelInfo="*">
                    <FBSCCYSuggest items={ccyList} selectedItem={CCYValue} onItemSelect={(ccyInfo) => { setCCYValue(ccyInfo) }}></FBSCCYSuggest>
                    {/* <InputGroup disabled={!isNew} id="d_Curcy" name="d_Curcy" defaultValue={cb.d_Curcy} placeholder="Currency ..." onChange={utils.handleStringChange(s => setValue("d_Curcy", s.toUpperCase()))} inputRef={register({ required: true , maxLength: 3}) } />
                    {errors.d_Curcy && errors.d_Curcy.type === "required" && <span id="Err_msg">Currency cannot be Blank</span>}
                    {errors.d_Curcy && errors.d_Curcy.type === "maxLength" && <span id="Err_msg">Max length is 3</span>} */}
                    {errors.d_Curcy && errors.d_Curcy.types && <span id="Err_msg">{errors.d_Curcy.types.message}</span>}
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label="Interest Code" labelFor="d_IntCode">
                    <InputGroup id="d_IntCode" name="d_IntCode" defaultValue={cb.d_IntCode} placeholder="Interest Code ..." onChange={utils.handleStringChange(s => setValue("d_IntCode", s.toUpperCase()))} inputRef={register({ maxLength: 2}) } />
                    {errors.d_IntCode && errors.d_IntCode.type === "maxLength" && <span id="Err_msg">Max length is 2</span>}
                    {errors.d_IntCode && errors.d_IntCode.types && <span id="Err_msg">{errors.d_IntCode.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-2-1" label="CR Interest" labelFor="d_CrIntMTD">
                    <InputGroup id="d_CrIntMTD" name="d_CrIntMTD" defaultValue={"0"} type="number" inputRef={register} />
                    {errors.d_CrIntMTD && errors.d_CrIntMTD.types && <span id="Err_msg">{errors.d_CrIntMTD.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-3-1" label="DR Interest" labelFor="d_DrIntMTD">
                    <InputGroup id="d_DrIntMTD" name="d_DrIntMTD" defaultValue={"0"} type="number" inputRef={register} />
                    {errors.d_DrIntMTD && errors.d_DrIntMTD.types && <span id="Err_msg">{errors.d_DrIntMTD.types.message}</span>}
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label="Last Month Net Equity" labelFor="d_BalBF">
                    <InputGroup id="d_BalBF" name="d_BalBF" defaultValue={"0"} type="number" inputRef={register} />
                    {errors.d_BalBF && errors.d_BalBF.types && <span id="Err_msg">{errors.d_BalBF.types.message}</span>}
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label="Last Day Net Equity" labelFor="d_BalMTD">
                    <InputGroup id="d_BalMTD" name="d_BalMTD" defaultValue={"0"} type="number" inputRef={register} />
                    {errors.d_BalMTD && errors.d_BalMTD.types && <span id="Err_msg">{errors.d_BalMTD.types.message}</span>}
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label="Fund In/Out" labelFor="d_InOut">
                    <InputGroup id="d_InOut" name="d_InOut" defaultValue={"0"} type="number" inputRef={register} />
                    {errors.d_InOut && errors.d_InOut.types && <span id="Err_msg">{errors.d_InOut.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-2-1" label="Commission" labelFor="d_Comm">
                    <InputGroup id="d_Comm" name="d_Comm" defaultValue={"0"} type="number" inputRef={register} />
                    {errors.d_Comm && errors.d_Comm.types && <span id="Err_msg">{errors.d_Comm.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-3-1" label="Exchange Fee" labelFor="d_Exchange">
                    <InputGroup id="d_Exchange" name="d_Exchange" defaultValue={"0"} type="number" inputRef={register} />
                    {errors.d_Exchange && errors.d_Exchange.types && <span id="Err_msg">{errors.d_Exchange.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-4-1" label="Levy" labelFor="d_Levy">
                    <InputGroup id="d_Levy" name="d_Levy" defaultValue={"0"} type="number" inputRef={register} />
                    {errors.d_Levy && errors.d_Levy.types && <span id="Err_msg">{errors.d_Levy.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-5-1" label="Profit & Loss" labelFor="d_PL">
                    <InputGroup id="d_PL" name="d_PL" defaultValue={"0"} type="number" inputRef={register} />
                    {errors.d_PL && errors.d_PL.types && <span id="Err_msg">{errors.d_PL.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-6-1" label="Net Equity">
                    <InputGroup readOnly value={utils.numToString2(cb.d_BalMTD+cb.d_PL+cb.d_Comm+cb.d_Exchange+cb.d_Levy+cb.d_PL)} />
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label="Open Trade Equity" labelFor="d_OTE">
                    <InputGroup id="d_OTE" name="d_OTE" defaultValue={"0"} type="number" inputRef={register} />
                    {errors.d_OTE && errors.d_OTE.types && <span id="Err_msg">{errors.d_OTE.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-6-1" label="Total Equity">
                    <InputGroup readOnly value={utils.numToString2(cb.d_BalMTD+cb.d_PL+cb.d_Comm+cb.d_Exchange+cb.d_Levy+cb.d_PL + cb.d_OTE)} />
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label="Init. Margin" labelFor="d_IMargin">
                    <InputGroup id="d_IMargin" name="d_IMargin" defaultValue={"0"} type="number" inputRef={register} />
                    {errors.d_IMargin && errors.d_IMargin.types && <span id="Err_msg">{errors.d_IMargin.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-2-1" label="Main. Margin" labelFor="d_MMargin">
                    <InputGroup id="d_MMargin" name="d_MMargin" defaultValue={"0"} type="number" inputRef={register} />
                    {errors.d_MMargin && errors.d_MMargin.types && <span id="Err_msg">{errors.d_MMargin.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-6-1" label="Excess/(Deficit)">
                    <InputGroup readOnly value={utils.numToString2(cb.d_BalMTD+cb.d_InOut+cb.d_Comm+cb.d_Exchange+cb.d_Levy+cb.d_PL + cb.d_OTE - cb.d_IMargin)} />
                </FormGroup>
            </div>
        </form>
    )
}

interface FBSCbMastMainProps {
    gsb: AxiosInstance
    type?: string
}

// const toaster = Toaster.create({
//     position: Position.TOP,
// })

function FBSCbMastMain({ gsb, type = "" }: FBSCbMastMainProps) {

    const imgWait = <img className="WaitIcon" src={svgWait2} alt="wait" />
    const coLogo = <img className="coLogo" src="coLogo.gif" alt="Co Logo" />

    let url = document.location.toString()
    let qString = url.substr(url.indexOf("?"))

    let { acCode: defaultSearchValue = "", ccy: defaultSearchValue2 }: { acCode: string, ccy: string } = useParams()

    const [isReadOnly, setisReadOnly] = useState(false)

    const [data, setData] = useState([] as FBSCbMast[])

    const [searchKey, setSearchKey] = useState("market")
    const [searchValue, setSearchValue] = useState(defaultSearchValue)
    const [searchValue2, setSearchValue2] = useState(defaultSearchValue2)

    const [nPage, setnPage] = useState(0)
    const [nTotalPage, setnTotalPage] = useState(0)
    const [aPageNumber, setaPageNumber] = useState([] as PageInfo[])
    const [MoblieDev, setMoblieDev] = useState(false)
    const [ShowWait, setShowWait] = useState(false)
    const [searchLimit, setSearchLimit] = useState(50)
    const [searchBackward, setSearchBackward] = useState(false)

    const [selectedTabId, setSelectedTabId] = useState("list")
    const [currentCb, setCurrentCb] = useState({} as FBSCbMast)

    const [currentMode, setCurrentMode] = useState("show")
    const [isShowAlert1, setisShowAlert1] = useState(false)
    const [ShowAlert1Msg, setShowAlert1Msg] = useState("")
    const [isShowAlert2, setisShowAlert2] = useState(false)
    const [ShowAlert2Msg, setShowAlert2Msg] = useState("")

    const [CO_NAME, setCO_NAME] = useState("")
    const [companyLogoName, setcompanyLogoName] = useState("")
    const [SBPath, setSBPath] = useState("")
    const [TRAN_DATE, setTRAN_DATE] = useState(utils.formatNumber(new Date()))
    const [SETL_DATE, setSETL_DATE] = useState(utils.formatNumber(new Date()))
    const [cardOpen01, setcardOpen01] = useState("cardOpen01-Theme0")

    const [ccyList, setCcyList] = useState([] as FBSCCYInfo[])

    useEffect(() => {
        (async () => {
            try {
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');
                GsbFlag = res.data.Flag;
                console.log("GsbFlag.user_key: ", GsbFlag.user_key)
                UserID = res.data.Flag.UserID
                setCO_NAME( GsbFlag.CO_NAME) ;
                setcompanyLogoName( GsbFlag.companyLogoName) ;
                setSBPath( GsbFlag.SBPath) 
                setTRAN_DATE(GsbFlag.TRAN_DATE ) ;
                setSETL_DATE(GsbFlag.SETL_DATE ) ;
                if ( GsbFlag.isProduction == "Y" ) {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME1);
                } else {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME2);
                }
            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])

    useEffect(() => {
        (async () => {
            try {
                const res = await gsb.post('/fbs/Master',
                    {   sb_data: {
                            by: "",
                            start: "",
                            nPage: 1,
                            limit: 0,
                            backward: false,
                            SortByName: false,
                                    filters: {
                            }
                        },
                        cPgmId: "CCYMast",
                        cAction: "ListRec",
                    });
                setCcyList(res.data.data)
            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])

    useEffect(() => {
        setisReadOnly(false)
        ;
        (async () => {
            try {
                UserID = (typeof UserID === 'string')? UserID.trim() : ''
                if ( UserID.trim().length > 0 ) {
                    const res = await gsb.post('/Master', {
                        sb_data: {
                            d_Userid2: UserID,
                            d_PgmCode: PgmCode
                        }, 
                        cPgmId: "UserPgmAccess", 
                        cAction: "GetUserPgmAccessInfo2"
                    })
                    //console.log("CbMastMain UserPgmAccess res.data.data", res.data.data)

                    if (res.data.ok) {
                        if ( res.data.data[0].d_PgmAction == "R" ) {
                            setisReadOnly(true)
                        }
                    }
                }
            } catch (error) {
                showErrorBox(error)
            }
        })()            
    }, [gsb, UserID])



    const PrevRecProcess = async (cb: FBSCbMast) => {
        try {
            const res = await gsb.post('/fbs/Master', {sb_data: cb, cPgmId: "CBMast", cAction: "PrevRec"})
            for (let i = 0; i < data.length; i++) {
                if (data[i].d_Acct+data[i].d_Curcy === res.data.data.d_Acct+res.data.data.d_Curcy) {
                    data[i] = { ...data[i], ...res.data.data }
                    setData(data)
                    break
                }
            }
            setCurrentCb(res.data.data)
            setCurrentMode("show")
        } catch (error) {
            utils.showError(error)
        }
    }

    const DeleteProcess = async (cb: FBSCbMast) => {
        try {
            //console.log("call DeleteProcess", stk)
            const res = await gsb.post('/fbs/Master', {sb_data: cb, cPgmId: "CBMast", cAction: "DelRec"})
            utils.showSuccess("Currency " + cb.d_Acct+" "+cb.d_Curcy + " record deleted")
            for (let i = 0; i < data.length; i++) {
                if (data[i].d_Acct+data[i].d_Curcy === res.data.data.d_Acct+res.data.data.d_Curcy) {
                    data[i] = { ...data[i], ...res.data.data }
                    setData(data)
                    break
                }
            }
            setCurrentCb(res.data.data)
            setCurrentMode("show")
        } catch (error) {
            utils.showError(error)
        }
    }

    const NextRecProcess = async (cb: FBSCbMast) => {
        try {
            const res = await gsb.post('/fbs/Master', {sb_data: cb, cPgmId: "CBMast", cAction: "NextRec"})
            for (let i = 0; i < data.length; i++) {
                if (data[i].d_Acct+data[i].d_Curcy === res.data.data.d_Acct+res.data.data.d_Curcy) {
                    data[i] = { ...data[i], ...res.data.data }
                    setData(data)
                    break
                }
            }
            setCurrentCb(res.data.data)
            setCurrentMode("show")
        } catch (error) {
            utils.showError(error)
        }
    }

    const newOnSave = async (cb: FBSCbMast) => {
        try {
            const res = await gsb.post('/fbs/Master', {sb_data: cb, cPgmId: "CBMast", cAction: "AddRec"})
            utils.showSuccess("Currency " + cb.d_Acct+" "+cb.d_Curcy + " record added")
            for (let i = 0; i < data.length; i++) {
                if (data[i].d_Acct+data[i].d_Curcy === res.data.data.d_Acct+res.data.data.d_Curcy) {
                    data[i] = { ...data[i], ...res.data.data }
                    setData(data)
                    break
                }
            }
            setCurrentCb(res.data.data)
            setCurrentMode("show")
        } catch (error) {
            //utils.showError(error)
            showErrorBox(error)
        }
    }

    const editOnSave = async (cb: FBSCbMast) => {
        try {
            const res = await gsb.post('/fbs/Master', {sb_data: cb, cPgmId: "CBMast", cAction: "UpdateRec"})
            utils.showSuccess("Currency " + cb.d_Acct+" "+cb.d_Curcy + " record saved")
            for (let i = 0; i < data.length; i++) {
                if (data[i].d_Acct+data[i].d_Curcy === res.data.data.d_Acct+res.data.data.d_Curcy) {
                    data[i] = { ...data[i], ...res.data.data }
                    //console.log("editOnSave data", i, data)
                    setData(data)
                    break
                }
            }
            //console.log("editOnSave res.data.data", res.data.data)
            setCurrentCb(res.data.data)
            setCurrentMode("show")
        } catch (error) {
            //utils.showError(error)
            showErrorBox(error)
        }
    }

    const onSubmit = async (e: FormEvent) => {
        e.preventDefault()

        setShowWait(true)
        setnPage(1)
        let m_limit = searchLimit
        if ( selectedTabId === "detail" ) {
            m_limit = 1
        }

        if ( utils.getDeviceType()) {
            setMoblieDev(true)
        } else {
            setMoblieDev(false)
        }
        
        try {
            //console.log("CbMastMain onsubmit called", data)
            if ( m_limit > 1 ) {
                const res = await gsb.post('/fbs/Master',
                {   sb_data: {
                        by: searchKey,
                        start: searchValue,
                        start2: searchValue2,
                        nPage: 1,
                        limit: m_limit,
                        backward: searchBackward,
                        filters: {
                            type: type
                        }, 
                    },
                    cPgmId: "CBMast",
                    cAction: "ListRec",
                });

                //console.log("onSubmit res.data.data", res.data.data)
                setData(res.data.data)
                if (res.data.data.length > 0) {
                    setCurrentCb(res.data.data[0])
                }
                
                if ( res.data.count > 0 ) {
                    const aPageNumber1 = []
                    if ( res.data.count > 0 ) {
                        setnTotalPage(Math.ceil(res.data.count / searchLimit))
                        for ( let j = 1; j <= Math.ceil(res.data.count / searchLimit); j++ ) {
                            aPageNumber1.push({n: j});
                        }
                        setaPageNumber(aPageNumber1)
                    }
                }
    
            } else {
                const res = await gsb.post('/fbs/Master',
                {   sb_data: {
                        d_Acct: searchValue,
                        d_Curcy: searchValue2,
                        nPage: 1,
                        limit: m_limit,
                    },
                    cPgmId: "CBMast",
                    cAction: "GetRec",
                });

                if ( res.data.ok ) {
                    //console.log("GetRec res.data.data", res.data.data)
                    setCurrentCb(res.data.data)
                    setCurrentMode("show")
                } else {
                    //alert(res.data.data)
                    setisShowAlert2(true)
                    setShowAlert2Msg(res.data.data)
                }
            }

            setShowWait(false)
        } catch (error) {
            setShowWait(false)
            utils.showError(error)
        }
    }

    useEffect(() => {
        if (defaultSearchValue.length > 0) {
            setShowWait(true)
            setnPage(1)
            if ( nPage > 0 ) {
                //setcPrintMode("PS")
            } 
    
            (async () => {
                //console.log("CbMastMain useEffect length > 0  called", data)
                const res = await gsb.post('/fbs/Master',
                    {   sb_data: {
                            by: "acct",
                            start: defaultSearchValue,
                            start2: defaultSearchValue2,
                            nPage: 1,
                            limit: 1,
                        },
                        cPgmId: "CBMast",
                        cAction: "ListRec",
                    });

                setData(res.data.data)
                if (res.data.data.length > 0) {
                    setCurrentCb(res.data.data[0])
                }
                setShowWait(false)
            })()
        }
    }, [gsb, defaultSearchValue, defaultSearchValue2])

    //Press page No 1 2 3 4
    useEffect(() => {
        if ( nPage > 0 && nPage <= nTotalPage && selectedTabId == "list" ) {
    
            setShowWait(true)
            if ( nPage > 0 ) {
                //setcPrintMode("S")
            } 
    
            (async () => {
                try {
                    const res = await gsb.post('/fbs/Master',
                    {   sb_data: {
                            by: searchKey,
                            start: searchValue,
                            start2: searchValue2,
                            nPage: nPage,
                            limit: searchLimit,
                            backward: searchBackward,
                            filters: {
                                type: type
                            }, 
                        },
                        cPgmId: "CBMast",
                        cAction: "ListRec",
                    });

                    setData(res.data.data)
                    if (res.data.data.length > 0) {
                        setCurrentCb(res.data.data[0])
                    }
                    setShowWait(false)
        
                } catch (error) {
                    utils.showError(error)
                }
            })()
        }
    }, [gsb, nPage, selectedTabId])
    

    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }

    // currentMode = show
    let detail = <FBSCbMastView gsb={gsb} cb={currentCb} baseUrl={gsb.defaults.baseURL} token={localStorage.getItem('token')} disableMovement={type==="B"} onPrevRec={() => PrevRecProcess(currentCb)} onNew={() => setCurrentMode("new")} onEdit={() => setCurrentMode("edit")} onDelete={() => DeleteProcess(currentCb)} onNextRec={() => NextRecProcess(currentCb)}></FBSCbMastView>
    switch (currentMode) {
        case "new":
            //console.log("currentMode = new")
            detail = <FBSCbMastEdit gsb={gsb} ccyList={ccyList} isNew onSave={newOnSave} onCancel={() => { setCurrentMode("show"); setSelectedTabId("detail") } }></FBSCbMastEdit>
            break
        case "edit":
            //console.log("currentMode = edit")
            detail = <FBSCbMastEdit gsb={gsb} ccyList={ccyList} cb={currentCb} onSave={editOnSave} onCancel={() => setCurrentMode("show")}></FBSCbMastEdit>
            break
        }

    let pagination = <Pagination nPage={nPage} nTotalPage={nTotalPage} aPageNumber={aPageNumber} setnPage={(n)=>setnPage(n)}></Pagination>
    
    let list = <>
        <div className="Row">
            <Button className="Col-1-1" disabled={isReadOnly} icon="add" onClick={() => { setCurrentMode("new"); setSelectedTabId("detail") }}>New</Button>
        </div>
        <div className="Spacing-V-16" />
        {ShowWait && <div>{imgWait}</div> }
        {nPage > 0 && pagination}
        {/* display search list */}
        <HTMLTable striped interactive condensed>
            <thead>
                <th className="TCol-100">Account</th>
                <th className="TCol-300">Name</th>
                <th className="TCol-100">Currency</th>
                <th className="TCol-150"><div className="Align-R">Ava. Balance</div></th>
                <th className="TCol-150"><div className="Align-R">O.T.E</div></th>
            </thead>
            <tbody id="ma_tr">
                {data.map((cb, i) =>
                    <tr key={i} onDoubleClick={() => { setSelectedTabId("detail") }}>
                        <td onClick={() => { setCurrentCb(cb) ; MoblieDev && setSelectedTabId("detail") }}>{cb.d_Acct}</td>
                        <td onClick={() => { setCurrentCb(cb) ; MoblieDev && setSelectedTabId("detail") }}>{cb.d_acName1}</td>
                        <td onClick={() => { setCurrentCb(cb) ; MoblieDev && setSelectedTabId("detail") }}>{cb.d_Curcy}</td>
                        <td onClick={() => { setCurrentCb(cb) ; MoblieDev && setSelectedTabId("detail") }}><div className="Align-R">{utils.numToString2(cb.d_BalMTD+cb.d_InOut+cb.d_Comm+cb.d_Exchange+cb.d_Levy+cb.d_PL)}</div></td>
                        <td onClick={() => { setCurrentCb(cb) ; MoblieDev && setSelectedTabId("detail") }}><div className="Align-R">{utils.numToString2(cb.d_OTE)}</div></td>
                        {/* <td onClick={() => { setCurrentCb(cb) }}>{cb.d_Action}</td> */}
                    </tr>
                )}
            </tbody>
        </HTMLTable>
        {ShowWait && nTotalPage > 0 && <div>{imgWait}</div> }
        {nPage > 0 && pagination}
    </>

    let CoHead = <SystemHeader companyLogo={companyLogoName} companyName={CO_NAME} dataPath={SBPath} tradeDate={TRAN_DATE} settlementDate={SETL_DATE}></SystemHeader>
    return (
        <>

            <form onSubmit={onSubmit}>
                <div className="Spacing-V-Menu"></div>                
                <div className="Row">
                    <FormGroup className="Col-1-12"  >
                        {CoHead}
                    </FormGroup>
                </div>
                <Card className={cardOpen01} interactive={false} elevation={Elevation.THREE} >
                    {type === "B" ? <H3>Clearing Agent Balance</H3> : <H3>Account Balance</H3>}
                    <div className="Spacing-V-16" />
                    <div className="Row">
                        {/* define search key */}
                        <FormGroup className="Col-1-5" label="Search for" labelFor="inputSearchValue">
                            <ControlGroup fill>
                                <HTMLSelect className={Classes.FIXED} value={searchKey} onChange={utils.handleStringChange(s => setSearchKey(s))}>
                                    <option value="acct">Account</option>
                                </HTMLSelect>
                                <InputGroup
                                    id="inputSearchValue"
                                    placeholder="Search"
                                    value={searchValue}
                                    onChange={utils.handleStringChange(s => setSearchValue(s))}
                                    leftIcon="search"
                                />
                                <InputGroup
                                    id="inputSearchValue2"
                                    placeholder=""
                                    value={searchValue2}
                                    onChange={utils.handleStringChange(s => setSearchValue2(s))}
                                    rightElement={<Button icon={IconNames.ARROW_RIGHT} disabled={(selectedTabId === "detail" && ! (searchKey == "acct"))} minimal type="submit"></Button>}
                                />
                            </ControlGroup>
                        </FormGroup>
                        <Button className="Col-6-1 Button-LabeledFormGroup" icon="search" disabled={(selectedTabId === "detail" && ! (searchKey == "acct"))} type="submit" >{(selectedTabId === "detail") ? "Search" : "List"}</Button>
                        </div>
                    <Tabs onChange={(newTabId) => setSelectedTabId(newTabId as string)} selectedTabId={selectedTabId}>
                        <Tab id="list" title="List" panel={list} />
                        <Tab id="detail" title="Detail" panel={detail} />
                    </Tabs>
                </Card>

                <div className="Spacing-V-16"></div>
                    <Alert
                        confirmButtonText="OK"
                        icon="tick-circle"
                        intent={Intent.SUCCESS}
                        isOpen={isShowAlert1}
                        onCancel={ () => setisShowAlert1(false) }
                        onConfirm={ () => { setShowAlert1Msg(""); setisShowAlert1(false) } }
                    >
                        <p>
                            {ShowAlert1Msg}
                        </p>
                    </Alert>
                    <Alert
                        confirmButtonText="OK"
                        icon="cross"
                        intent={Intent.WARNING}
                        isOpen={isShowAlert2}
                        onCancel={ () => setisShowAlert2(false) }
                        onConfirm={ () => { setShowAlert2Msg(""); setisShowAlert2(false) } }
                    >
                        <p>
                            {ShowAlert2Msg}
                        </p>
                    </Alert>
            </form>
        </>
    );
}

export default FBSCbMastMain